import * as React from 'react';

import {
  goToLocations,
  ifLoggedIn,
  locationsUrl,
  canadaSiteUrl,
  canadaSiteFrUrl,
  USSiteUrl,
  goToUSSite,
  goToCanadaSiteFr,
  goToCanadaSite,
  canadaSiteEn,
  canadaSiteEnUrl,
  goToTracking,
  trackingUrl
} from 'src/utils/navigation';
import './MoreMenuItem.scss';
import moreIcon from 'src/assets/moreIcon';
// import USAFlag from 'src/components/RegionSwitch/assets/usaflag';
import CANADAFlag from 'src/components/RegionSwitch/assets/canadaflag';
import location from 'src/assets/locationIcon';
import usaFlag from 'src/components/RegionSwitch/assets/usaflag';
import i18n from 'src/translation/i18n';
import { env } from 'src/shared/env';

interface IMoreMenuItemState {
  floatingIsOpen: boolean;
}

interface IMoreMenuItemProps {
  isLoggedIn: boolean;
}

export default class MoreMenuItem extends React.Component<
  any,
  IMoreMenuItemState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private goToLocations = () => ifLoggedIn(() => goToLocations());
  private goToCanadaSite = () => ifLoggedIn(() => goToCanadaSite());
  private goToUSSite = () => ifLoggedIn(() => goToUSSite());
  private goToCanadaSiteFr = () => ifLoggedIn(() => goToCanadaSiteFr());
  private gotToMyTracking = () => ifLoggedIn(() => goToTracking());

  private changeCountrySite = (goTo: () => void) => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      this.props.signout();
      goTo();
    } else {
      goTo();
    }
  };

  private changeCountrySiteCA = (goTo: () => void) => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      goTo();
    } else {
      this.props.signout();
      goTo();
    }
  };

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        id="my-more-menu"
        onMouseOut={this.closeMenu}
        onMouseOver={this.openMenu}
        className="my-more-menu"
      >
        <div
          className="my-orders-menu--my-account my-orders-menu--my-account-more"
          onClick={this.handleMenuState}
        >
          <div className="my-orders-menu--info">
            <img src={moreIcon} alt="more icon" className="your-order-icon" /><br/>
            <button  className="go-to-account">
              <p className="rp-more-text">{i18n.t('common.more')} </p>
            </button >
          </div>
        </div>
        <div
          className={`my-orders-menu--my-account--fly-menu ${menuState}`}
          ref={ref => (this.flyMenuRef = ref)}
        >
          <p className="menu-item-heading">{i18n.t('common.more')}</p>

          <a
            href={locationsUrl()}
            className="menu-item menu-link"
            onClick={this.goToLocations}
          >
            <img src={location} alt="icon" className="menu-item-icon" />
            {t('common.locationTxt')}
          </a>
          <a
            href={trackingUrl()}
            className="menu-item menu-link tabview-more"
            onClick={this.gotToMyTracking}
          >
            <img src={location} alt="icon" className="menu-item-icon" />
            {i18n.t('menu.myTracking')}
          </a>
          <a
            href={USSiteUrl()}
            className="menu-item menu-link"
            onClick={e => this.changeCountrySite(goToUSSite)}
          >
            <img src={usaFlag} alt="icon" className="menu-item-icon" />
            {t('common.usEnglish')}
          </a>
          <a
            href={canadaSiteEnUrl()}
            className="menu-item menu-link"
            onClick={e => this.changeCountrySiteCA(canadaSiteEn)}
          >
            <img src={CANADAFlag} alt="icon" className="menu-item-icon" />
            {t('common.caEnglish')}
          </a>
          <a
            href={canadaSiteFrUrl()}
            className="menu-item menu-link"
            onClick={e => this.changeCountrySiteCA(goToCanadaSiteFr)}
          >
            <img src={CANADAFlag} alt="icon" className="menu-item-icon" />
            {t('common.caFr')}
          </a>
        </div>
      </div>
    );
  }
}
